<template>
    <div>
        <b-form-group
            id="fieldset-1"
            :description="description"
            :label="text"
            :label-for="name"
            :label-class="labelClass"
            :label-size="labelSize"
        >
            <div :id="`input_${name}`">
                <!-- Invisible file selector -->
                <input
                    v-bind="$attrs"
                    ref="fileSelector"
                    type="file"
                    :id="name"
                    :name="name"
                    :value="value"
                    @change="$_onChange"
                    :data-fieldname="name"
                />
            </div>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        props: {
            description: { type: String, required: false },
            name: { type: String, required: false, default: 'Upload-input' },
            text: { type: String, required: false, default: '' },
            labelSize: { type: String, required: false, default: '' },
            value: [String, Number],
            labelClass: { type: String, default: 'font-weight-normal' },
            maxSize: { type: Number, default: 20971520 }
        },

        data() {
            return { fileName: 'Geen bestand gekozen' };
        },

        methods: {
            /**
             * File selected event handler
             * @param  {object} event [holds the selected files]
             */
            async $_onChange(event) {
                this.$emit('loading', true);
                const files = event.currentTarget.files;
                if (files.length > 0) {
                    this.fileName = files[0].name;
                    // get the bound data-fieldname property
                    const dataFieldname =
                        this.$refs.fileSelector.getAttribute('data-fieldname');
                    // read file content
                    const result = await this.readFileContent(files);
                    // send selected file event
                    this.$emit('loading', false);
                    this.$emit('selected', result, dataFieldname, this.fileName);
                } else {
                    this.fileName = 'Geen bestand gekozen';
                    this.$emit('loading', false);
                }
            },

            /**
             * Show the image file selector
             */
            $_selectFile() {
                // call click on the hidden file selector
                this.$refs.fileSelector.click();
            },

            /**
             * Read the image content
             * @param  {Array} files   [selected image files]
             * @return {object}        [Promise object]
             */
            readFileContent(files) {
                return new Promise((resolve, reject) => {
                    // het geselecteerde bestand
                    const file = files[0];
                    const size = file.size;
                    if (file && this.maxSize !== 0 && size > this.maxSize) {
                        reject(new Error('Bestand is te groot'));
                        return;
                    }

                    try {
                        // read file
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const data = e.target.result;
                            const type = e.target.result.split(';')[0];
                            // result
                            resolve({
                                data,
                                type,
                                size
                            });
                        };
                        reader.readAsDataURL(file);
                    } catch (error) {
                        reject(error);
                    }
                });
            }
        }
    };
</script>
